import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/modules/store';

/**
 * アプリケーション設定情報マスタを利用するカスタムフック
 */
const useApplicationVariableList = () => {
  const { applicationVariableMstList } = useSelector((state: AppState) => state.masterInfo);

  /**
   * 指定したreferenceCdに対応する(string or number)のリストを返却
   * @param  referenceCd https://docs.google.com/spreadsheets/d/1_dwX7L4Zboe3T75hLYInVkDjizSkvphYW14bKdVgXDc/edit?usp=drive_link
   * @returns Array<string> | Array<number> もしくは空配列
   */
  const getApplicationVariableByReferenceCd = useCallback(
    (referenceCd: string) => {
      if (referenceCd.startsWith('STR')) {
        return (
          applicationVariableMstList
            .find((v) => v.referenceCd === referenceCd)
            ?.applicationVariableStringMstList.map((variable) => variable.valueString) || []
        );
      }
      if (referenceCd.startsWith('INT')) {
        return (
          applicationVariableMstList
            .find((v) => v.referenceCd === referenceCd)
            ?.applicationVariableIntMstList.map((variable) => variable.valueInt) || []
        );
      }
      // referenceCdのprefixが想定外の場合、空配列を返す
      return [];
    },
    [applicationVariableMstList]
  );

  return { getApplicationVariableByReferenceCd };
};

export default useApplicationVariableList;
